namespace GeniuzPOS.Purchase {
    export class ListAppPurOrderColumns {
        static columnsKey = 'Purchase.ListAppPurOrder';
    }
}
